import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import homeIcon from "../images/home.jpg";
import { FaSignOutAlt, FaChevronDown } from "react-icons/fa";
import { hasAccess } from "../utils/access";

const CustomNavbar = () => {
  const [username, setUsername] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSubDropdown, setOpenSubDropdown] = useState(null);
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const menuRef = useRef(null);
  const location = useLocation();
  // const userId = user?.id || parseInt(localStorage.getItem("userId"), 10);
  // const designation =
  // user?.designation || localStorage.getItem("designation");

  const role =
    user?.role || localStorage.getItem("role");

  const dashboardAccess =
    user?.dashboardAccess ||
    JSON.parse(localStorage.getItem("dashboard_access") || "{}");

  // const hasMenuAccess = (menuKey) => {
  //   // Admin can see everything
  //   if (dashboardAccess.dashboard_admin) return true;

  //   // ✅ NEW: When BOTH coordinator AND expense are true,
  //   // only show Scheme, Daily Working, and Expense
  //   if (
  //     dashboardAccess.dashboard_coordinator &&
  //     dashboardAccess.dashboard_expense
  //   ) {
  //     return [
  //       "scheme-reports",
  //       "daily-working",
  //       "expenses",
  //       "master-data",
  //     ].includes(menuKey);
  //   }

  //   const menuMap = {
  //     "master-data": dashboardAccess.dashboard_coordinator,
  //     dcr: dashboardAccess.dashboard_coordinator,
  //     messaging: dashboardAccess.dashboard_coordinator,
  //     "tour-program": dashboardAccess.dashboard_coordinator,
  //     reports: dashboardAccess.dashboard_coordinator,
  //     "daily-working": dashboardAccess.dashboard_coordinator,

  //     cosmacia: dashboardAccess.dashboard_cosmesia,
  //     kpkb: dashboardAccess.dashboard_kpkb,
  //     expenses: dashboardAccess.dashboard_expense,
  //   };

  //   return menuMap[menuKey] === true;
  // };

  const hasMenuAccess = (menuKey) => {
    const designation =
      user?.employee_data?.designation ||
      localStorage.getItem("designation");
    const role = user?.role || localStorage.getItem("role") || localStorage.getItem("userRole");


    if (role === "NSM") {
      return menuKey === "daily-working";
    }

    if (dashboardAccess.dashboard_admin) return true;

    if (
      dashboardAccess.dashboard_coordinator &&
      dashboardAccess.dashboard_expense
    ) {
      return [
        "scheme-reports",
        "daily-working",
        "expenses",
        "master-data",
      ].includes(menuKey);
    }

    const menuMap = {
      "master-data": dashboardAccess.dashboard_coordinator,
      dcr: dashboardAccess.dashboard_coordinator,
      messaging: dashboardAccess.dashboard_coordinator,
      "tour-program": dashboardAccess.dashboard_coordinator,
      reports: dashboardAccess.dashboard_coordinator,
      "daily-working": dashboardAccess.dashboard_coordinator,

      cosmacia: dashboardAccess.dashboard_cosmesia,
      kpkb: dashboardAccess.dashboard_kpkb,
      expenses: dashboardAccess.dashboard_expense,
    };

    return menuMap[menuKey] === true;
  };
  // Item-level access control
  // const hasMenuItemAccess = (menuKey, itemKey) => {
  //   const userId = user?.id || parseInt(localStorage.getItem("userId"), 10);

  //   // SUPERADMIN has full access to all items
  //   if (userId === 335) {
  //     return true;
  //   }

  //   // --- COORDINATOR-14 restrictions ---
  //   if (userId === 405) {
  //     // Define restricted items for COORDINATOR-14
  //     const restrictedItems = {
  //       "master-data": [
  //         "admin-items", // Hide admin items
  //         "broadcast", // Hide broadcast
  //         "logout", // Hide logout options
  //         "extra-team",
  //       ],
  //       dcr: [
  //         "hide-team", // Hide hide-team option
  //         "delete-dcr",
  //       ],
  //       "tour-program": ["delete-executive-tp", "delete-manager-tp"],
  //       reports: [
  //         "fake-reporting", // Hide fake reporting
  //       ],
  //     };

  //     // Check if this item is restricted for COORDINATOR-14
  //     if (
  //       restrictedItems[menuKey] &&
  //       restrictedItems[menuKey].includes(itemKey)
  //     ) {
  //       return false;
  //     }

  //     return hasMenuAccess(menuKey);
  //   }

  //   // --- Cosmacia user (665) ---
  //   if (userId === 665) {
  //     // Only allow access if it's a normal menu item
  //     if (menuKey === "cosmacia") {
  //       return true; // All cosmacia items
  //     }

  //     // For normal menus, check if user has access to that menu
  //     if (hasMenuAccess(menuKey)) {
  //       // For normal users, allow most items but restrict admin items
  //       if (menuKey === "master-data") {
  //         const restrictedItems = ["admin-items", "broadcast", "logout"];
  //         return !restrictedItems.includes(itemKey);
  //       }
  //       return true;
  //     }
  //     return false;
  //   }

  //   // --- KPKB user (663) ---
  //   if (userId === 663) {
  //     // Only allow access if it's a normal menu item
  //     if (menuKey === "kpkb") {
  //       return true; // All kpkb items
  //     }

  //     // For normal menus, check if user has access to that menu
  //     if (hasMenuAccess(menuKey)) {
  //       // For normal users, allow most items but restrict admin items
  //       if (menuKey === "master-data") {
  //         const restrictedItems = ["admin-items", "broadcast", "logout"];
  //         return !restrictedItems.includes(itemKey);
  //       }
  //       return true;
  //     }
  //     return false;
  //   }

  //   // --- Expense user (664) ---
  //   if (userId === 664) {
  //     // Only show expense items
  //     if (menuKey === "expenses") {
  //       return true; // All expense items
  //     }
  //     return false;
  //   }

  //   // --- For other normal users ---
  //   // Get user division for Cosmacia/KPKB access
  //   const userDivision = user?.division || localStorage.getItem("userDivision");

  //   // Handle Cosmacia division users
  //   if (userDivision === "Cosmacia" || userDivision === "cosmacia") {
  //     if (menuKey === "cosmacia") {
  //       return true; // All cosmacia items for division users
  //     }
  //   }

  //   // Handle KPKB division users
  //   if (userDivision === "KPKB" || userDivision === "kpkb") {
  //     if (menuKey === "kpkb") {
  //       return true; // All kpkb items for division users
  //     }
  //   }

  //   // Expense is hidden for all normal users
  //   if (menuKey === "expenses") {
  //     return false;
  //   }

  //   // For other menus, use the original permission logic
  //   const menuConfig = menuPermissions[menuKey];
  //   if (!menuConfig) return false;

  //   const itemConfig = menuConfig.items && menuConfig.items[itemKey];
  //   if (!itemConfig) return false;

  //   return true;
  // };
  // 🔐 CENTRALIZED COORDINATOR PERMISSIONS
  const COORDINATOR_ACCESS = {
    "master-data": {
      allowAll: true,
      block: [
        "distributor",
        "company",
        "unlock-dcr",
        "dcr-leave-type",
        "expense",
        "product",
        "employee-rights",
        "extra-team",
        "broadcast",
        "logout",
      ],
    },

    dcr: {
      allowAll: true,
    },

    reports: {
      allow: [
        "schemes",
        "scheme-report",
        "preview-dcr",
        "gps-location",
        "dcs-assigned",
        "manager-vs-team",
        "pob-achievement",
        "monthly-attendance",
        "chemist-frequency",
        "chemist-missed",
        "stockist-visit",
        "chemist-added",
      ],
    },

    "daily-working": {
      allow: [
        "daily-attendance",
        "daily-analysis",
        "pob-reports",
        "sob-reports",
        "pob-vs-sob",
        "field-force",
        "attendance-sheet",
        "actual-working",
        "employee-statewise",
        "rrr-report", // ✅ RRR
      ],
    },
  };

  const COORDINATOR_MASTER_BLOCKED = [
    "distributor",
    "company",
    "expense",
    "product",
    "employee-rights",
    "extra-team",
    "logout",
  ];

  const coordinatorHasAccess = (menuKey, itemKey) => {
    const config = COORDINATOR_ACCESS[menuKey];
    if (!config) return false;

    if (config.allowAll) {
      return !config.block?.includes(itemKey);
    }

    if (config.allow) {
      return config.allow.includes(itemKey);
    }

    return false;
  };

  const hasMenuItemAccess = (menuKey, itemKey) => {
    const designation =
      user?.employee_data?.designation ||
      localStorage.getItem("designation");

    const role =
      user?.role || localStorage.getItem("role");

    if (role === "NSM") {
      return menuKey === "daily-working";
    }

    // Admin → full access
    if (dashboardAccess.dashboard_admin) return true;

    if (
      dashboardAccess.dashboard_coordinator &&
      dashboardAccess.dashboard_expense
    ) {
      if (
        menuKey === "reports" &&
        ["schemes", "scheme-report"].includes(itemKey)
      )
        return true;

      if (menuKey === "daily-working") return true;
      if (menuKey === "expenses") return true;

      if (
        menuKey === "master-data" &&
        ["stockist", "pob-target"].includes(itemKey)
      )
        return true;

      return false;
    }

    // If parent menu not allowed → block
    if (!hasMenuAccess(menuKey)) return false;

    if (dashboardAccess.dashboard_coordinator) {
      if (menuKey === "master-data") {
        if (COORDINATOR_MASTER_BLOCKED.includes(itemKey)) {
          return false;
        }
        return true;
      }

      const restrictedItems = {
        reports: ["fake-reporting"],
      };

      if (
        restrictedItems[menuKey] &&
        restrictedItems[menuKey].includes(itemKey)
      ) {
        return false;
      }

      return true;
    }

    if (dashboardAccess.dashboard_cosmesia) {
      return menuKey === "cosmacia";
    }

    if (dashboardAccess.dashboard_kpkb) {
      return menuKey === "kpkb";
    }

    if (dashboardAccess.dashboard_expense) {
      return menuKey === "expenses";
    }

    return false;
  };

  // Sample data (unchanged)
  const pobData = [
    {
      EMPID: "007",
      EMPLOYEE: "Nareshreddy Malreddy",
      POB_TARGET: "1300000",
      SOB_TARGET: "1300000",
      FROM_DATE: "01-Nov-2021",
    },
    {
      EMPID: "002",
      EMPLOYEE: "B.Sridhar",
      POB_TARGET: "1300000",
      SOB_TARGET: "1300000",
      FROM_DATE: "01-Apr-2021",
    },
  ];

  const sobData = [
    {
      EMPID: "007",
      EMPLOYEE: "Nareshreddy Malreddy",
      TARGET: "1300000",
      From_Date: "2021-04-01",
    },
    {
      EMPID: "002",
      EMPLOYEE: "B.Sridhar",
      TARGET: "250000",
      From_Date: "2021-04-01",
    },
  ];

  const productData = [
    {
      SKU: "P001",
      Name: "Meglow Sunscreen",
      Brand: "Cosmacia",
      Category: "Sunscreen",
      Buying_Price: "120",
      Selling_Price: "150",
      Stock: "100",
    },
    {
      SKU: "P002",
      Name: "Engine Hair Oil",
      Brand: "Engine",
      Category: "Hair Oil",
      Buying_Price: "80",
      Selling_Price: "100",
      Stock: "250",
    },
  ];

  // --- Permissions config (kept for reference but overridden by ID logic) ---
  const menuPermissions = {
    "master-data": {
      base: ["superadmin", "admin", "coordinator", "manager"],
      items: {
        "employee-record": ["superadmin", "admin", "coordinator"],
        "add-employee": ["superadmin", "admin", "coordinator"],
        "edit-employee": ["superadmin", "admin", "coordinator", "manager"],
        "user-panel": ["superadmin", "admin", "coordinator", "manager", "user"],
        "extra-team": ["superadmin", "admin", "coordinator", "manager", "user"],
        "employee-rights": [
          "superadmin",
          "admin",
          "coordinator",
          "manager",
          "user",
        ],
        "add-city": ["superadmin", "admin", "coordinator"],
        "assigned-city": ["superadmin", "admin", "coordinator"],
        area: ["superadmin", "admin", "coordinator"],
        "retain-delete-area": ["superadmin", "admin"],
        route: ["superadmin", "admin", "coordinator"],
        stockist: ["superadmin", "admin", "coordinator"],
        mobile: ["superadmin", "admin", "coordinator"],
        chemist: ["superadmin", "admin", "coordinator"],
        "sob-target": ["superadmin", "admin", "coordinator"],
        "pob-target": ["superadmin", "admin", "coordinator"],
        "admin-items": ["superadmin"],
        broadcast: ["superadmin", "admin", "coordinator"],
        logout: ["superadmin", "admin", "coordinator"],
      },
    },
    dcr: {
      base: ["superadmin", "admin", "coordinator", "manager", "user"],
      items: {
        leave: ["superadmin", "admin", "coordinator", "manager", "user"],
        "leave-remarks": ["superadmin", "admin", "coordinator"],
        "unlock-dcr": ["superadmin", "admin", "coordinator"],
        "dcr-leave-type": ["superadmin", "admin", "coordinator"],
        "update-pob": ["superadmin", "admin", "coordinator"],
        "delete-dcr": ["superadmin", "admin", "coordinator"],
        "remove-dr-retailer": ["superadmin", "admin", "coordinator"],
        "hide-team": ["superadmin", "admin"],
      },
    },
    messaging: {
      base: ["superadmin", "admin", "coordinator"],
      items: {
        "send-mail": ["superadmin", "admin", "coordinator"],
        "send-login-details": ["superadmin"],
        "send-simple-sms": ["superadmin", "admin", "coordinator"],
        "send-group-sms": ["superadmin", "admin"],
        "stockist-pob-sms": ["superadmin", "admin", "coordinator"],
        "stockist-pob-sms-missed": ["superadmin", "admin"],
      },
    },
    "tour-program": {
      base: ["superadmin", "admin", "coordinator", "manager"],
      items: {
        "edit-tour-program": ["superadmin", "admin", "coordinator", "manager"],
        "approve-tour": ["superadmin", "admin", "coordinator"],
        "delete-executive-tp": ["superadmin", "admin"],
        "delete-manager-tp": ["superadmin", "admin"],
      },
    },
    reports: {
      base: ["superadmin", "admin", "coordinator", "manager"],
      items: {
        "preview-dcr": ["superadmin", "admin", "coordinator", "manager"],
        "gps-location": ["superadmin", "admin", "coordinator"],
        "dcs-assigned": ["superadmin", "admin", "coordinator", "manager"],
        "fake-reporting": ["superadmin"],
        "manager-vs-team": ["superadmin", "admin", "coordinator"],
        "pob-achievement": ["superadmin", "admin", "coordinator", "manager"],
        "monthly-attendance": ["superadmin", "admin", "coordinator", "manager"],
        "chemist-frequency": ["superadmin", "admin", "coordinator"],
        "chemist-missed": ["superadmin", "admin", "coordinator"],
        "pob-slabs": ["superadmin", "admin"],
        "stockist-visit": ["superadmin", "admin", "coordinator"],
        "chemist-added": ["superadmin", "admin", "coordinator"],
        schemes: ["superadmin", "admin", "coordinator"],
        "scheme-report": ["superadmin", "admin", "coordinator"],
      },
    },
    "daily-working": {
      base: ["superadmin", "admin", "coordinator", "manager"],
      items: {
        "daily-attendance": ["superadmin", "admin", "coordinator", "manager"],
        "daily-analysis": ["superadmin", "admin", "coordinator", "manager"],
        "pob-reports": ["superadmin", "admin", "coordinator", "manager"],
        "sob-reports": ["superadmin", "admin", "coordinator", "manager"],
        "pob-vs-sob": ["superadmin", "admin", "coordinator"],
        "field-force": ["superadmin", "admin", "coordinator", "manager"],
        "dcr-visits": ["superadmin", "admin", "coordinator", "manager"],
        "attendance-sheet": ["superadmin", "admin", "coordinator", "manager"],
        "actual-working": ["superadmin", "admin", "coordinator", "manager"],
        "employee-statewise": ["superadmin", "admin", "coordinator"],
      },
    },
    kpkb: {
      base: ["superadmin", "admin", "coordinator"],
    },
    cosmacia: {
      base: ["superadmin", "admin", "coordinator"],
    },
    expenses: {
      base: ["superadmin", "admin", "coordinator"],
      items: {
        "expense-report-view": ["superadmin", "admin", "coordinator"],
        "edit-monthly-ff": ["superadmin", "admin", "coordinator"],
      },
    },
  };

  // --- Utility helpers ---

  // CSV escaping according to RFC4180-ish (double quotes doubled)
  const escapeCsv = (value) => {
    if (value === null || value === undefined) return "";
    const s = String(value);
    return `"${s.replace(/"/g, '""')}"`;
  };

  // --- Download functions (cleaned) ---
  const downloadPobExcelFormat = () => {
    try {
      const headers = Object.keys(pobData[0]).join(",");
      const rows = pobData
        .map((item) =>
          Object.values(item)
            .map((value) => escapeCsv(value))
            .join(","),
        )
        .join("\n");

      const csvContent = `${headers}\n${rows}`;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "POB_Master_Format.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("downloadPobExcelFormat error", err);
    }
  };

  const downloadSobExcelFormat = () => {
    try {
      const headers = Object.keys(sobData[0]).join(",");
      const rows = sobData
        .map((item) =>
          Object.values(item)
            .map((value) => escapeCsv(value))
            .join(","),
        )
        .join("\n");

      const csvContent = `${headers}\n${rows}`;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "SOB_Master_Format.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("downloadSobExcelFormat error", err);
    }
  };

  // Client-generated Product CSV (keeps your CSV approach)
  const downloadProductExcelFormat = () => {
    try {
      const headers = Object.keys(productData[0]).join(",");
      const rows = productData
        .map((item) =>
          Object.values(item)
            .map((value) => escapeCsv(value))
            .join(","),
        )
        .join("\n");

      const csvContent = `${headers}\n${rows}`;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Product_Master_Format.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("downloadProductExcelFormat error", err);
    }
  };

  const SobTargetFormat = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const link = document.createElement("a");
    link.href = "/SOBTargetFormatBulk.xlsx"; // ensure file exists at public/SOBTargetFormat.xlsx
    link.download = "SOBTargetFormatBulk.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // --- UI / menu helpers ---

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, [user]);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await logout();
    } catch (error) {
      console.error("Logout error:", error);
      localStorage.clear();
      window.location.href = "/login";
    }
  };

  // Click-based handlers for main menu
  const handleMainMenuClick = (tab) => {
    if (openDropdown === tab) {
      setOpenDropdown(null);
      setOpenSubDropdown(null);
    } else {
      setOpenDropdown(tab);
      setOpenSubDropdown(null);
    }
  };

  // Click-based handlers for submenu
  const handleSubMenuClick = (subTab) => {
    if (openSubDropdown === subTab) {
      setOpenSubDropdown(null);
    } else {
      setOpenSubDropdown(subTab);
    }
  };

  // Close all menus when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenDropdown(null);
        setOpenSubDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close menus when navigating
  const handleNavigation = () => {
    setOpenDropdown(null);
    setOpenSubDropdown(null);
  };

  function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Render admin-only menu items
  const renderAdminItems = () => {
    return (
      <>
        {hasMenuItemAccess("master-data", "distributor") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("distributor")}
            >
              Distributor
              <FaChevronDown size={12} />
            </div>
            {openSubDropdown === "distributor" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                <Link
                  to="/admin/add-distributors"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add Distributor
                </Link>
                <Link
                  to="/admin/view-distributors"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  View Distributors
                </Link>
              </div>
            )}
          </div>
        )}

        {/* Broadcast dropdown (new) */}
        {hasMenuItemAccess("master-data", "broadcast") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("broadcast")}
            >
              Broadcast
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "broadcast" ? "rotate-180" : ""
                  }`}
              />
            </div>
            {openSubDropdown === "broadcast" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                <Link
                  to="/admin/add-broadcast-message"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add Broadcast
                </Link>

                <Link
                  to="/admin/broadcast-message"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Edit Broadcast
                </Link>
              </div>
            )}
          </div>
        )}

        {/* logout dropdown (new) */}
        {hasMenuItemAccess("master-data", "logout") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("logout")}
            >
              Logout
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "logout" ? "rotate-180" : ""
                  }`}
              />
            </div>
            {openSubDropdown === "logout" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                <Link
                  to="/admin/logout-all-users"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  All User Unlock
                </Link>
              </div>
            )}
          </div>
        )}

        {/* Company Details dropdown */}
        {hasMenuItemAccess("master-data", "company") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("company")}
            >
              Company Details
              <FaChevronDown size={12} />
            </div>
            {openSubDropdown === "company" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                <Link
                  to="/admin/add-state"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add State
                </Link>
                <Link
                  to="/admin/add-substate"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add Substate
                </Link>
                <Link
                  to="/admin/add-designation"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add Designation
                </Link>
                <Link
                  to="/admin/company-schemes"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Company Scheme
                </Link>
                <Link
                  to="/admin/add-division"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add Division
                </Link>
              </div>
            )}
          </div>
        )}
        {/* Expense dropdown */}
        {hasMenuItemAccess("master-data", "expense") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("expense")}
            >
              Expense
              <FaChevronDown size={12} />
            </div>

            {openSubDropdown === "expense" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                <Link
                  to="/admin/Expense-management"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add Expense
                </Link>
                <Link
                  to="/admin/edit-employee-expense"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Edit Expense
                </Link>
                <Link
                  to="/admin/Expense-history"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Expense History
                </Link>
                <Link
                  to="/admin/travel-policy"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Travel Policy
                </Link>
              </div>
            )}
          </div>
        )}

        {hasMenuItemAccess("master-data", "product") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("product")}
            >
              Product
              <FaChevronDown size={12} />
            </div>

            {openSubDropdown === "product" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                <Link
                  to="/admin/add-product"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add Product
                </Link>
                <Link
                  to="/admin/edit-product"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Edit Product
                </Link>
                <Link
                  to="/admin/product-price"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Product Price
                </Link>

                {/* Or client CSV */}
                <div
                  onClick={() => {
                    downloadProductExcelFormat();
                    handleNavigation();
                  }}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] cursor-pointer"
                >
                  Product CSV Format
                </div>
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  // Render dropdowns (master data, dcr, etc.)
  const renderMasterDataDropdown = () => {
    const isCombined =
      dashboardAccess.dashboard_coordinator &&
      dashboardAccess.dashboard_expense;

    return (
      <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">
        {/* Employee Record */}
        {hasMenuItemAccess("master-data", "employee-record") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("employee-record")}
            >
              Employee Record
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "employee-record" ? "rotate-180" : ""}`}
              />
            </div>
            {openSubDropdown === "employee-record" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                {hasMenuItemAccess("master-data", "add-employee") && (
                  <Link
                    to="/add-employee"
                    onClick={handleNavigation}
                    className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                  >
                    Add Employee
                  </Link>
                )}
                <div
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href = "/employee_download.xlsx";
                    link.download = "Employee_Excel_Format.xlsx";
                    link.click();
                  }}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] cursor-pointer"
                >
                  Employee Excel Format
                </div>
                {hasMenuItemAccess("master-data", "edit-employee") && (
                  <Link
                    to="/select-employee"
                    onClick={handleNavigation}
                    className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                  >
                    Edit Employee
                  </Link>
                )}
                {hasMenuItemAccess("master-data", "user-panel") && (
                  <Link
                    to="/user-panel"
                    onClick={handleNavigation}
                    className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                  >
                    User Password
                  </Link>
                )}
                {hasMenuItemAccess("master-data", "extra-team") && (
                  <Link
                    to="/admin/extrateam"
                    onClick={handleNavigation}
                    className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                  >
                    Extra Team
                  </Link>
                )}
                {hasMenuItemAccess("master-data", "employee-rights") && (
                  <Link
                    to="/admin/employee-rights"
                    onClick={handleNavigation}
                    className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                  >
                    Employee Rights
                  </Link>
                )}
              </div>
            )}
          </div>
        )}

        {/* City */}
        {hasMenuItemAccess("master-data", "add-city") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("City")}
            >
              City
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "City" ? "rotate-180" : ""}`}
              />
            </div>
            {openSubDropdown === "City" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                {hasMenuItemAccess("master-data", "add-city") && (
                  <Link
                    to="/city"
                    onClick={handleNavigation}
                    className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                  >
                    Add City
                  </Link>
                )}
                {hasMenuItemAccess("master-data", "assigned-city") && (
                  <Link
                    to="/assigned-city"
                    onClick={handleNavigation}
                    className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                  >
                    Assign City
                  </Link>
                )}
              </div>
            )}
          </div>
        )}

        {/* Combined case: flat links only */}
        {isCombined && hasMenuItemAccess("master-data", "stockist") && (
          <Link
            to="/liststockist"
            onClick={handleNavigation}
            className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
          >
            View/Assign Stockist
          </Link>
        )}
        {isCombined && hasMenuItemAccess("master-data", "pob-target") && (
          <Link
            to="/pob-employee-target"
            onClick={handleNavigation}
            className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
          >
            POB vs SOB Target Report
          </Link>
        )}

        {/* Admin-only items */}
        {renderAdminItems()}

        {/* Area */}
        {hasMenuItemAccess("master-data", "area") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("Area")}
            >
              Area
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "Area" ? "rotate-180" : ""}`}
              />
            </div>
            {openSubDropdown === "Area" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                <Link
                  to="/area"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add/View Area
                </Link>
              </div>
            )}
          </div>
        )}

        {/* Route */}
        {hasMenuItemAccess("master-data", "route") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("Route")}
            >
              Route
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "Route" ? "rotate-180" : ""}`}
              />
            </div>
            {openSubDropdown === "Route" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                <Link
                  to="/addroute"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Add Route
                </Link>
                <Link
                  to="/editroute"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Edit Employee Route
                </Link>
              </div>
            )}
          </div>
        )}

        {/* Stockist - full dropdown, hidden in combined case */}
        {!isCombined && hasMenuItemAccess("master-data", "stockist") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("Stockist")}
            >
              Stockist
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "Stockist" ? "rotate-180" : ""}`}
              />
            </div>
            {openSubDropdown === "Stockist" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                {hasMenuItemAccess("master-data", "add-employee") && (
                  <Link
                    to="/addstockist"
                    onClick={handleNavigation}
                    className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                  >
                    Add Stockist
                  </Link>
                )}
                <Link
                  to="/liststockist"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  View/Assign Stockist
                </Link>
                <Link
                  to="/employeestockist-list"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Stockist Employee List
                </Link>
              </div>
            )}
          </div>
        )}

        {/* Mobile */}
        {hasMenuItemAccess("master-data", "mobile") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("Mobile")}
            >
              Mobile
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "Mobile" ? "rotate-180" : ""}`}
              />
            </div>
            {openSubDropdown === "Mobile" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                <Link
                  to="/mobile-register"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Register Device ID
                </Link>
                <Link
                  to="/registered-device"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Employee Mobile Detail
                </Link>
                <Link
                  to="/admin/latest-Battery-stats"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Latest Battery Stats
                </Link>
              </div>
            )}
          </div>
        )}

        {/* POB vs SOB Target - full dropdown, hidden in combined case */}
        {!isCombined && hasMenuItemAccess("master-data", "pob-target") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("POB-Target")}
            >
              POB vs SOB Target
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "POB-Target" ? "rotate-180" : ""}`}
              />
            </div>
            {openSubDropdown === "POB-Target" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                {hasMenuItemAccess("master-data", "add-employee") && (
                  <Link
                    to="/pob-employee-target"
                    onClick={handleNavigation}
                    className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                  >
                    POB vs SOB Target Report
                  </Link>
                )}
                {/* <div
                  onClick={() => {
                    downloadPobExcelFormat();
                    handleNavigation();
                  }}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] cursor-pointer"
                >
                  POB vs SOB Excel Format
                </div> */}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // DCR Dropdown
  const renderDCRDropdown = () => (
    <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">
      {hasMenuItemAccess("dcr", "leave") && (
        <div className="relative">
          <div
            className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
            onClick={() => handleSubMenuClick("leave")}
          >
            Leave
            <FaChevronDown
              size={12}
              className={`transition-transform duration-300 ${openSubDropdown === "leave" ? "rotate-180" : ""
                }`}
            />
          </div>
          {openSubDropdown === "leave" && (
            <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
              <Link
                to="/leave-application"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                Leave Application
              </Link>
              {hasMenuItemAccess("dcr", "leave-remarks") && (
                <Link
                  to="/leave-remarks"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  Leave Remarks
                </Link>
              )}
            </div>
          )}
        </div>
      )}

      {hasMenuItemAccess("dcr", "unlock-dcr") && (
        <Link
          to="/unlock-dcr"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Unlock DCR
        </Link>
      )}

      {hasMenuItemAccess("dcr", "dcr-leave-type") && (
        <Link
          to="/leavetype-dcr"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          DCR Leave Type
        </Link>
      )}

      {/* {hasMenuItemAccess("dcr", "delete-dcr") && (
        <Link
          to="/deletedcr"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Delete DCR
        </Link>
      )} */}

      {hasMenuItemAccess("dcr", "remove-dr-retailer") && (
        <div className="relative">
          <div
            className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
            onClick={() => handleSubMenuClick("Remove DR + Retailer")}
          >
            Remove DR + Retailer
            <FaChevronDown
              size={12}
              className={`transition-transform duration-300 ${openSubDropdown === "Remove DR + Retailer" ? "rotate-180" : ""
                }`}
            />
          </div>
          {openSubDropdown === "Remove DR + Retailer" && (
            <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 whitespace-nowrap z-50">
              <Link
                to="/ViewChemist"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                Remove Duplicate Rtr/Dr
              </Link>
              <Link
                to="/NonVisitRetailer"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                All Non Visited Retailers
              </Link>
            </div>
          )}
        </div>
      )}

        {hasMenuItemAccess("dcr", "dcr-leave-type") && (
        <Link
          to="/unfreeze-location"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Unfreeze Locations
        </Link>
      )}
    </div>
  );

  // Messaging Dropdown
  const renderMessagingDropdown = () => (
    <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">
      {hasMenuItemAccess("messaging", "send-mail") && (
        <Link
          to="/sendmail"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Send Mail
        </Link>
      )}

      {hasMenuItemAccess("messaging", "send-simple-sms") && (
        <Link
          to="/messageemp"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Send Simple SMS
        </Link>
      )}

      {hasMenuItemAccess("messaging", "stockist-pob-sms") && (
        <Link
          to="/messagestockist"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Stockist POB SMS
        </Link>
      )}
    </div>
  );

  // Tour Program Dropdown
  const renderTourProgramDropdown = () => (
    <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">
      {hasMenuItemAccess("tour-program", "edit-tour-program") && (
        <div
          className="relative px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer"
          onClick={() => {
            navigate("/tour-program");
            handleNavigation();
          }}
        >
          Tour Program
        </div>
      )}
    </div>
  );

  // Reports Dropdown
  const renderReportsDropdown = () => (
    <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">
      {hasMenuItemAccess("reports", "preview-dcr") && (
        <div
          onClick={handleNavigation}
          className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer"
        >
          Preview DCR
        </div>
      )}

      {hasMenuItemAccess("reports", "gps-location") && (
        <Link
          to="/locationhistorysms"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          GPS Location History
        </Link>
      )}

      {hasMenuItemAccess("reports", "dcs-assigned") && (
        <Link
          to="/dcsassigned"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Doctor Chemist Stockist Assigned
        </Link>
      )}

      {hasMenuItemAccess("reports", "fake-reporting") && (
        <div
          onClick={handleNavigation}
          className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer"
        >
          Fake Reporting - Wifi Mock GLS
        </div>
      )}

      {hasMenuItemAccess("reports", "manager-vs-team") && (
        <Link
          to="/locationmrvsmgr"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Manager Vs Team
        </Link>
      )}

      {hasMenuItemAccess("reports", "pob-achievement") && (
        <Link
          to="/dcrmonthlyinslabscheme"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          POB Achievement
        </Link>
      )}

      {hasMenuItemAccess("reports", "monthly-attendance") && (
        <Link
          to="/punchedattendencestatewise"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Monthly Punch Attendance
        </Link>
      )}

      {hasMenuItemAccess("reports", "chemist-frequency") && (
        <div className="relative">
          <div
            className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
            onClick={() => handleSubMenuClick("DCR Doctor Retailer")}
          >
            DCR Doctor Retailer
            <FaChevronDown
              size={12}
              className={`transition-transform duration-300 ${openSubDropdown === "DCR Doctor Retailer" ? "rotate-180" : ""
                }`}
            />
          </div>
          {openSubDropdown === "DCR Doctor Retailer" && (
            <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
              <Link
                to="/chemistcallfrequency"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                Retailer Call Frequency
              </Link>
              <Link
                to="/chemistmissedcall"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                Retailer Missed
              </Link>
            </div>
          )}
        </div>
      )}

      {hasMenuItemAccess("reports", "pob-slabs") && (
        <Link
          to="/dcrmonthlypobstockistslabemployeereport"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          POB Stockist Employee Slab
        </Link>
      )}

      {hasMenuItemAccess("reports", "stockist-visit") && (
        <Link
          to="/stockistvisitreport"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Employee Stockist List
        </Link>
      )}

      {hasMenuItemAccess("reports", "chemist-added") && (
        <div
          onClick={handleNavigation}
          className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer"
        >
          Chemist Added Monthly
        </div>
      )}
    </div>
  );

  // Scheme Reports Dropdown
  const renderSchemeReportsDropdown = () => {
    const isCombined = dashboardAccess.dashboard_coordinator && dashboardAccess.dashboard_expense;

    return (
      <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">

        {/* Deal Delight - hidden in combined case */}
        {!isCombined && hasMenuItemAccess("daily-working", "daily-analysis") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("DEAL_DELIGHT")}
            >
              <span>Deal Delight</span>
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "DEAL_DELIGHT" ? "rotate-180" : ""
                  }`}
              />
            </div>
            {openSubDropdown === "DEAL_DELIGHT" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                {renderDealDelightDropdown()}
              </div>
            )}
          </div>
        )}

        {/* Daily Temptation - always show */}
        {hasMenuItemAccess("daily-working", "daily-analysis") && (
          <div className="relative">
            <div
              className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
              onClick={() => handleSubMenuClick("Daily Temptation")}
            >
              <span>Daily Temptation</span>
              <FaChevronDown
                size={12}
                className={`transition-transform duration-300 ${openSubDropdown === "Daily Temptation" ? "rotate-180" : ""
                  }`}
              />
            </div>
            {openSubDropdown === "Daily Temptation" && (
              <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
                {renderDailyTemptationOptions()}
              </div>
            )}
          </div>
        )}

      </div>
    );
  };
  const renderDealDelightDropdown = () => (
    <>
      <Link
        to="/admin/deal-delight-monthly"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
      >
        RTR Wise Deal Delight
      </Link>

      <Link
        to="/admin/deal-delight-ff-count"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
      >
        FF Wise Deal Delight
      </Link>
    </>
  );
  const renderDailyTemptationOptions = () => (
    <>
      {/* <Link
        to="/admin/product-campaign-temptation"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
      >
        Product Campaign
      </Link> */}
      <Link
        to="/admin/MonthCount-temptation"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
      >
        FF Wise Temptation
      </Link>
      <Link
        to="/admin/product-wise-temptation"
        onClick={handleNavigation}
        className="block px-3 py-2 border-b border-black hover:bg-[#9cb3e0] no-underline"
      >
        Product Wise Temptation
      </Link>

      {/* <Link
        to="/admin/stateWise-temptation"
        onClick={handleNavigation}
        className="block px-3 py-2 border-b border-black hover:bg-[#9cb3e0] no-underline"
      >
        State Wise Product
      </Link> */}
    </>
  );

  // Daily Working Dropdown
  const renderDailyWorkingDropdown = () => (
    <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">
      {hasMenuItemAccess("daily-working", "daily-attendance") && (
        <Link
          to="/dailypunchedattendence"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Daily Punch Attendance
        </Link>
      )}

      {hasMenuItemAccess("daily-working", "daily-analysis") && (
        <div className="relative">
          <div
            className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
            onClick={() => handleSubMenuClick("Daily Working Analysis")}
          >
            Daily Working Analysis
            <FaChevronDown
              size={12}
              className={`transition-transform duration-300 ${openSubDropdown === "Daily Working Analysis" ? "rotate-180" : ""
                }`}
            />
          </div>
          {openSubDropdown === "Daily Working Analysis" && (
            <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
              <Link
                to="/dfr"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                DFR
              </Link>
            </div>
          )}
        </div>
      )}

      {hasMenuItemAccess("daily-working", "pob-reports") && (
        <div className="relative">
          <div
            className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
            onClick={() => handleSubMenuClick("pob")}
          >
            POB
            <FaChevronDown
              size={12}
              className={`transition-transform duration-300 ${openSubDropdown === "pob" ? "rotate-180" : ""
                }`}
            />
          </div>
          {openSubDropdown === "pob" && (
            <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
              <Link
                to="/pobdata"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                POB
              </Link>
              <Link
                to="/pobdatewise"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                POB Date Wise
              </Link>
              {/* <div className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0]">
                POB Target vs Achievement
              </div> */}
              {hasMenuItemAccess("daily-working", "rrr-report") && (
                <Link
                  to="/admin/rrr-report"
                  onClick={handleNavigation}
                  className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
                >
                  RRR Reports
                </Link>
              )}

              <Link
                to="/pobfy"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                POB FY
              </Link>
              <Link
                to="/mslpob"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                MSL POB
              </Link>
            </div>
          )}
        </div>
      )}

      {hasMenuItemAccess("daily-working", "sob-reports") && (
        <div className="relative">
          <div
            className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
            onClick={() => handleSubMenuClick("sob")}
          >
            SOB
            <FaChevronDown
              size={12}
              className={`transition-transform duration-300 ${openSubDropdown === "sob" ? "rotate-180" : ""
                }`}
            />
          </div>
          {openSubDropdown === "sob" && (
            <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
              <Link
                to="/sobfy"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                SOB FY
              </Link>
              <Link
                to="/stockistsobfy"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                Stockist SOB FY
              </Link>
            </div>
          )}
        </div>
      )}

      {hasMenuItemAccess("daily-working", "pob-vs-sob") && (
        <div className="relative">
          <div
            className="px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
            onClick={() => handleSubMenuClick("POB Vs SOB")}
          >
            POB Vs SOB
            <FaChevronDown
              size={12}
              className={`transition-transform duration-300 ${openSubDropdown === "POB Vs SOB" ? "rotate-180" : ""
                }`}
            />
          </div>
          {openSubDropdown === "POB Vs SOB" && (
            <div className="absolute left-full top-0 bg-[#b0c4e6] text-black border border-black w-56 z-50">
              <div
                onClick={() => {
                  SobTargetFormat();
                  handleNavigation();
                }}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] cursor-pointer"
              >
                SOB Target Format (.xlsx)
              </div>
              <Link
                to="/sobtargetstockist"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                Upload SOB Target
              </Link>
              <Link
                to="/stockistpobsobadd"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                Add
              </Link>
              <Link
                to="/stockistpobsobtargetquarterly"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                Target vs POB vs SOB Quarterly
              </Link>
              <Link
                to="/employeepobsobtargetquarterly"
                onClick={handleNavigation}
                className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
              >
                Employee Achievement Quarterly
              </Link>
            </div>
          )}
        </div>
      )}

      {hasMenuItemAccess("daily-working", "field-force") && (
        <Link
          to="/fieldforcedata"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Field Force Working Report
        </Link>
      )}

      {hasMenuItemAccess("daily-working", "attendance-sheet") && (
        <Link
          to="/attendencesheet"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Attendance Sheet
        </Link>
      )}

      {hasMenuItemAccess("daily-working", "actual-working") && (
        <Link
          to="/reporting/actual-working"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline whitespace-nowrap"
        >
          Actual Working (TP Vs DCR)
        </Link>
      )}

      {hasMenuItemAccess("daily-working", "employee-statewise") && (
        <Link
          to="/employeestatewise"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Employee Statewise
        </Link>
      )}
      {/* {hasMenuItemAccess("daily-working", "fake-reporting") && (
        <Link
          to="/admin/fake-reporting-wifi-mock-gls"
          onClick={handleNavigation}
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
        >
          Fake Report- Wifi Mock GLS
        </Link>
      )}
    */}
    </div>
  );

  // Cosmacia Dropdown
  const renderCosmaciaDropdown = () => (
    <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">
      <Link
        to="/ffmonthlycount"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        FF Monthly Product Count
      </Link>
      <Link
        to="/state-wise-product-set"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        State Wise Product
      </Link>
      <Link
        to="/cosmacia-product-list"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        FF RTR WISE Product
      </Link>
      <Link
        to="/cosmacia-product-sales-slab"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Price List
      </Link>

      {/* <div className="relative">
        <div
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
          onClick={() => handleSubMenuClick("Cosmacia Scheme")}
        >
          Cosmacia Scheme
          <FaChevronDown 
            size={12}
            className={`transition-transform duration-300 ${
              openSubDropdown === "Cosmacia Scheme" ? "rotate-180" : ""
            }`}
          />
        </div>
        {openSubDropdown === "Cosmacia Scheme" && (
          <div className="absolute left-full top-0 bg-[#cbd6f1] border border-black w-56">
            <Link
              to="/cosmacia-product-wise-scheme"
              onClick={handleNavigation}
              className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
            >
              Product Wise Scheme
            </Link>
            <Link
              to="/cosmacia-product-wise-sale"
              onClick={handleNavigation}
              className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
            >
              Product Wise Sale
            </Link>
          </div>
        )}
      </div> */}
    </div>
  );

  // KPKB Dropdown
  const renderKPKBDropdown = () => (
    <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">
      <Link
        to="/kpkb-state-wise-product"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        State Wise Product
      </Link>
      <Link
        to="/kpkb-product-list"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        FF Product Wise
      </Link>
      <Link
        to="/kpkb-monthly-sales"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Monthly Product Sales
      </Link>
      <Link
        to="/kpkb-monthly-sales-pot"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Monthly Product Sales POB
      </Link>
      <Link
        to="/kpkb-monthly-sales-qtr"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Monthly Product Sales Qty
      </Link>
      <Link
        to="/kpkb-product-sales-in-slab"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Price List
      </Link>

      {/* <div className="relative">
        <div
          className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] cursor-pointer flex items-center justify-between"
          onClick={() => handleSubMenuClick("KPKB Scheme")}
        >
          Cosmacia Scheme
          <FaChevronDown 
            size={12}
            className={`transition-transform duration-300 ${
              openSubDropdown === "KPKB Scheme" ? "rotate-180" : ""
            }`}
          />
        </div>
        {openSubDropdown === "KPKB Scheme" && (
          <div className="absolute left-full top-0 bg-[#cbd6f1] border border-black w-56">
            <Link
              to="/kpkb-product-wise-scheme"
              onClick={handleNavigation}
              className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
            >
              Product Wise Scheme
            </Link>
            <Link
              to="/kpkb-product-wise-sale"
              onClick={handleNavigation}
              className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
            >
              Product Wise Sale
            </Link>
          </div>
        )}
      </div> */}
    </div>
  );

  // Expenses Dropdown
  const renderExpensesDropdown = () => (
    <div className="absolute left-0 top-full bg-[#cbd6f1] text-black border border-black w-56 z-50">
      <Link
        to="/expense/edit-monthly-ff"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Approved Expense Report
      </Link>
      <Link
        to="/expense/expense-report-fff"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Expense FY
      </Link>
      <Link
        to="/expense/expense-print"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Expense Print
      </Link>
      <Link
        to="/admin/Expense-history"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
      >
        Expense History
      </Link>
      <Link
        to="/admin/travel-policy"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
      >
        Travel Policy
      </Link>
      <Link
        to="/editroute"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#9cb3e0] no-underline"
      >
        Edit Employee Route
      </Link>
      <Link
        to="/unlock-dcr"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Unlock DCR
      </Link>
      <Link
        to="/employeestatewise"
        onClick={handleNavigation}
        className="block px-3 py-1 border-b border-black hover:bg-[#b0c4e6] no-underline"
      >
        Employee Statewise
      </Link>
    </div>
  );

  // --- Render component ---
  return (
    <div className="w-full" ref={menuRef}>
      {/* User Welcome Container */}
      <div className="flex justify-between items-center p-2 bg-gray-100 border-b border-black">
        <div className="flex items-center space-x-4"></div>
        <div className="flex items-center space-x-4">
          <span className="text-gray-700 text-sm">
            Welcome, {username ? capitalizeFirstLetter(username) : "User"}
          </span>
          <div
            onClick={handleLogout}
            className="flex items-center space-x-1 bg-red-500 text-white px-3 py-1.5 rounded-full text-sm cursor-pointer hover:bg-red-600 transition duration-200 shadow"
            title="Logout"
          >
            <FaSignOutAlt className="w-4 h-4" />
            <span>Logout</span>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <div className="relative">
        <nav className="main-navbar flex bg-[#e0e6f8] border border-black h-8">
          {hasMenuAccess("master-data") && (
            <div className="relative">
              <div
                className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                onClick={() => handleMainMenuClick("master-data")}
              >
                Master Data
              </div>
              {openDropdown === "master-data" && renderMasterDataDropdown()}
            </div>
          )}

          {hasMenuAccess("dcr") && (
            <div className="relative">
              <div
                className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                onClick={() => handleMainMenuClick("dcr")}
              >
                DCR
              </div>
              {openDropdown === "dcr" && renderDCRDropdown()}
            </div>
          )}

          {hasMenuAccess("messaging") && (
            <div className="relative">
              <div
                className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                onClick={() => handleMainMenuClick("messaging")}
              >
                Messaging
              </div>
              {openDropdown === "messaging" && renderMessagingDropdown()}
            </div>
          )}

          {hasMenuAccess("tour-program") && (
            <div className="relative">
              <div
                className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                onClick={() => handleMainMenuClick("tour-program")}
              >
                Tour Program
              </div>
              {openDropdown === "tour-program" && renderTourProgramDropdown()}
            </div>
          )}

          {/* {hasMenuAccess("reports") && userId !== 335 && (
            <div className="relative">
              <div
                className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                onClick={() => handleMainMenuClick("reports")}
              >
                Reports
              
              </div>
              {openDropdown === "reports" && renderReportsDropdown()}
            </div>
          )} */}
          {role !== "NSM" &&
            (hasMenuItemAccess("reports", "schemes") ||
              hasMenuItemAccess("reports", "scheme-report")) && (
              <div className="relative">
                <div
                  className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                  onClick={() => handleMainMenuClick("scheme-reports")}
                >
                  Scheme
                </div>
                {openDropdown === "scheme-reports" &&
                  renderSchemeReportsDropdown()}
              </div>
            )}

          {hasMenuAccess("daily-working") && (
            <div className="relative">
              <div
                className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                onClick={() => handleMainMenuClick("daily-working")}
              >
                Daily Working
              </div>
              {openDropdown === "daily-working" && renderDailyWorkingDropdown()}
            </div>
          )}

          {hasMenuAccess("cosmacia") && (
            <div className="relative">
              <div
                className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                onClick={() => handleMainMenuClick("cosmacia")}
              >
                Cosmacia
              </div>
              {openDropdown === "cosmacia" && renderCosmaciaDropdown()}
            </div>
          )}

          {hasMenuAccess("kpkb") && (
            <div className="relative">
              <div
                className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                onClick={() => handleMainMenuClick("kpkb")}
              >
                KPKB
              </div>
              {openDropdown === "kpkb" && renderKPKBDropdown()}
            </div>
          )}

          {hasMenuAccess("expenses") && (
            <div className="relative">
              <div
                className="border-r border-black px-3 py-1 hover:bg-[#cbd6f1] cursor-pointer flex items-center justify-between"
                onClick={() => handleMainMenuClick("expenses")}
              >
                Expense
              </div>
              {openDropdown === "expenses" && renderExpensesDropdown()}
            </div>
          )}

          {/* Home Button - Show only on /dashboard */}
          {location.pathname !== "/dashboard" && (
            <div className="absolute top-0 right-1">
              <img
                src={homeIcon}
                alt="Home"
                className="w-12 h-8 object-contain cursor-pointer"
                onClick={() => navigate("/dashboard")}
                title="Go to Dashboard"
              />
            </div>
          )}
        </nav>
      </div>
    </div>
  );
};

export default CustomNavbar;
